import { render, staticRenderFns } from "./PurchaseSearchBrowse.vue?vue&type=template&id=141e1e80"
import script from "./PurchaseSearchBrowse.vue?vue&type=script&lang=ts"
export * from "./PurchaseSearchBrowse.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('141e1e80')) {
      api.createRecord('141e1e80', component.options)
    } else {
      api.reload('141e1e80', component.options)
    }
    module.hot.accept("./PurchaseSearchBrowse.vue?vue&type=template&id=141e1e80", function () {
      api.rerender('141e1e80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/purchases/PurchaseSearchBrowse.vue"
export default component.exports